import { render } from "./VideoScroll.vue?vue&type=template&id=74e1a57e&scoped=true"
import script from "./VideoScroll.vue?vue&type=script&lang=js"
export * from "./VideoScroll.vue?vue&type=script&lang=js"

import "./VideoScroll.vue?vue&type=style&index=0&id=74e1a57e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74e1a57e"]])

export default __exports__